import React, { Fragment } from "react";
import Header from "../../CommonComponents/header";
import { MobileHeader } from "../../CommonComponents/mobileHeader";
import { Footer } from "../../CommonComponents/footer";
import CertificationCard from "./Components/CertificationCard";
import { BlogHeroSection } from "../BlogsPage/Components/blogHeroSection";

export default function CertificationPage() {
  return (
    <Fragment>
      <Header />
      <MobileHeader />
      <div style={{height:"100px"}} ></div>
      <BlogHeroSection pagetitle={"Certification"}  imageUrl={"/assets/images/new_images/banners/blog_banner.jpg"} white={"black"} />

      <section style={{paddingTop:"50px"}} >
       <div className="certification_container">
        <CertificationCard/>
       </div>
      </section>
      <Footer />
    </Fragment>
  );
}
